import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";
import { COMPANY } from "@/data/content";

const DEFAULTS = {
  hero_title_line1: "Vakmanschap begint",
  hero_title_line2: "bij vertrouwen.",
  hero_subtitle:
    "Klusbedrijf Pruijn realiseert complete renovaties, verbouwingen en afwerkingen met oog voor detail. Van badkamer tot complete woningrenovatie.",
  about_heading: "Kwaliteit, communicatie en echt vakmanschap.",
  about_text:
    "Klusbedrijf Pruijn staat voor kwaliteit, duidelijke communicatie en vakmanschap. Wij begeleiden renovaties van A tot Z en leveren uitsluitend werk af waar we zelf trots op zijn.",
  about_image:
    "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cta_title: "Klaar om uw woning te verbeteren?",
  cta_text: "Vraag vrijblijvend een offerte aan of bel ons direct. We denken graag met u mee.",
  phone: COMPANY.phone,
  phoneRaw: COMPANY.phoneRaw,
  whatsapp: COMPANY.whatsapp,
  email: COMPANY.email,
  location: COMPANY.location,
  kvk: COMPANY.kvk,
  btw: COMPANY.btw,
  website: COMPANY.website,
  instagram: COMPANY.instagram,
  facebook: COMPANY.facebook,
  tiktok: COMPANY.tiktok,
  google: COMPANY.google,
  work_areas: ["Arnhem", "Huissen", "Bemmel", "Nijmegen", "Duiven", "Westervoort", "Elst", "Lingewaard"],
  logo_url: COMPANY.logo,
  nav_logo_height: 48,
  hero_logo_height: 200,
  footer_logo_height: 112,
  why_us: [
    { icon: "User", title: "Eén aanspreekpunt", text: "Van begin tot eind één vaste contactpersoon die alles regelt." },
    { icon: "MessagesSquare", title: "Heldere communicatie", text: "Korte lijnen en duidelijke afspraken, u weet altijd waar u aan toe bent." },
    { icon: "CalendarCheck", title: "Strakke planning", text: "We houden ons aan de planning en werken efficiënt en netjes." },
    { icon: "Award", title: "Hoogwaardige afwerking", text: "Wij leveren uitsluitend werk af waar we zelf trots op zijn." },
  ],
  process: [
    { title: "Kennismaking", text: "We bespreken uw wensen en bekijken de mogelijkheden ter plaatse." },
    { title: "Offerte", text: "U ontvangt een heldere, transparante offerte zonder verrassingen." },
    { title: "Planning", text: "We stellen een strakke planning op die past bij uw situatie." },
    { title: "Uitvoering", text: "Vakkundige uitvoering met één vast aanspreekpunt." },
    { title: "Oplevering", text: "Nette oplevering en een woning waar we samen trots op zijn." },
  ],
};

const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/settings")
      .then((res) => {
        const data = res.data || {};
        // Merge: keep defaults for any missing/empty key
        const merged = { ...DEFAULTS };
        Object.keys(data).forEach((k) => {
          if (data[k] !== undefined && data[k] !== null && data[k] !== "") merged[k] = data[k];
        });
        setSettings(merged);
      })
      .catch(() => {});
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
